import React from 'react'
import { Icon } from "@material-ui/core";
import HasuraLogo from './hasura-icon-primary.svg'

export const HasuraIcon = () => (
    React.createElement(Icon, null
        , React.createElement('img', { src: HasuraLogo, alt: "", height: 25, width: 25,})
    )
)